import uuid from 'uuid/v4';

// note: must export this way so we can stub for unit testing
// eslint-disable-next-line import/prefer-default-export
export const randomUuid = () => uuid();
